<div class="row">
  <div class="col-lg-4" *ngIf="data?.ivtDistribution?.givtSivtRate && data?.ivtDistribution?.givtSivtRate !== 'N/A'">
    <div class="progress-circle-chart mx-auto" *ngIf="!isFreemium">
      <app-progress-circle [classref]="'.ivt-progress-circle-chart'" [max]="100"
        [value]="data?.ivtDistribution?.givtSivtRate * 100">
        <div class="ivt-progress-circle-chart" style="width: 214px; height: 214px; margin:auto;"></div>
      </app-progress-circle>
      <div class="graph-legend progress-circle">
        <div class="big-number color-H">
          {{data?.ivtDistribution?.givtSivtRate | perc:'1.2-2'}}
        </div>
        <div class="desc-text color-H"></div>
      </div>
    </div>
    <div class="progress-circle-chart mx-auto" *ngIf="isFreemium">
      <app-progress-circle [classref]="'.ivt-progress-circle-chart'" [max]="100" [value]="0">
        <div class="ivt-progress-circle-chart" style="width: 214px; height: 214px; margin:auto;"></div>
      </app-progress-circle>
      <div class="graph-legend progress-circle">
        <div class="big-number" *ngIf="!isFollowing">
          ??
        </div>
        <div class="big-number color-H" *ngIf="isFollowing">
          {{data?.ivtDistribution?.givtSivtRate | perc:'1.2-2'}}
        </div>
        <div class="desc-text color-H"></div>
      </div>
    </div>

    <div class="breakdowns">
      <div class="d-flex breakdown-item">
        <div class="label">
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="SIVT refers to Sophisticated Invalid Traffic - Probabilistically judged to be non-human traffic using advanced statistical detection methods; moderate to high risk traffic">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a> SIVT
        </div>
        <div class="progress-bar-cont d-flex">
          <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
            <div class="progress sivt" [style.width]="(data?.ivtDistribution?.sivtRate * 100) + '%'"></div>
            <div class="percent">{{data?.ivtDistribution?.sivtRate | perc: '1.2-2'}}</div>
          </ng-container>
          <ng-container *ngIf="isFreemium && !isFollowing">
            <div class="percent">??</div>
          </ng-container>
        </div>
      </div>
      <div class="d-flex breakdown-item">
        <div class="label">
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="GIVT refers to General Invalid Traffic - Deterministically judged to be non-human traffic; high to very high risk.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a> GIVT
        </div>
        <div class="progress-bar-cont d-flex">
          <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
            <div class="progress givt" [style.width]="(data?.ivtDistribution?.givtRate * 100) + '%'"></div>
            <div class="percent">{{data?.ivtDistribution?.givtRate | perc: '1.2-2'}} </div>
          </ng-container>
          <ng-container *ngIf="isFreemium && !isFollowing">??</ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-8" *ngIf="!isFreemium">
    <div class="container-fluid pl-0 info-list has-info-icon">
      <app-bar-chart [data]="barChartData" [categoryField]="'month'" [valueFields]="['givtRate', 'sivtRate']"
        [titleArray]="['GIVT', 'SIVT']" [type]="'double'"></app-bar-chart>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <div class="container-fluid pl-0 info-list has-info-icon height-unset"
      *ngIf="isFreemium || data?.ivtDistribution?.sivtFraudTypes?.length > 0">
      <h3 class="sub-title">
        SIVT Types
        <a class="btn btn-link p-0" data-toggle="tooltip"
          title="The type of sophisticated invalid traffic (SIVT) designation associated to such IVT.  All IVT calculations are derived from standardized definitions of invalid traffic maintained by the Media Rating Council, Inc. (MRC), Interactive Advertising Bureau (IAB), and Trustworthy Accountability Group (TAG).">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
        </a>
      </h3>
      <ng-container *ngFor="let fraudType of data?.ivtDistribution?.sivtFraudTypes; let i = index;">
        <div class="d-flex info-list-item fraud-types align-items-center">
          <div class="label">
            <a class="btn btn-link help-icon p-0" data-toggle="tooltip"
              [attr.title]="tooltipMapping[fraudType?.fraudType]">
              <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
            </a> {{fraudType?.name}}
          </div>
          <div class="value" *ngIf="!isFreemium">
            {{fraudType?.totalTrafficRatio | perc: '1.2-2'}}
          </div>
          <div class="progress-bar-cont" *ngIf="!isFreemium">
            <div class="progress sivt" [style.width]="((fraudType?.totalTrafficRatio / maxValue) * 100)+'%'"></div>
          </div>
        </div>
        <div class="divider mt-2px" *ngIf="i < data?.ivtDistribution?.sivtFraudTypes?.length - 1"></div>
      </ng-container>
    </div>
    <div class="container-fluid pl-0 info-list has-info-icon height-unset givt-types-cont"
      *ngIf="isFreemium || data?.ivtDistribution?.givtFraudTypes?.length > 0">
      <h3 class="sub-title">
        GIVT Types
        <a class="btn btn-link p-0" data-toggle="tooltip"
          title="The type of general invalid traffic (GIVT) designation associated to such IVT.  All IVT calculations are derived from standardized definitions of invalid traffic maintained by the Media Rating Council, Inc. (MRC), Interactive Advertising Bureau (IAB), and Trustworthy Accountability Group (TAG).">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
        </a>
      </h3>
      <ng-container *ngFor="let fraudType of data?.ivtDistribution?.givtFraudTypes; let i = index;">
        <div class="d-flex info-list-item fraud-types align-items-center">
          <div class="label">
            <a class="btn btn-link help-icon p-0" data-toggle="tooltip"
              [attr.title]="tooltipMapping[fraudType?.fraudType]">
              <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
            </a> {{fraudType?.name}}
          </div>
          <div class="value" *ngIf="!isFreemium">
            {{fraudType?.totalTrafficRatio | perc: '1.2-2'}}
          </div>
          <div class="progress-bar-cont" *ngIf="!isFreemium">
            <div class="progress givt" [style.width]="((fraudType?.totalTrafficRatio / maxValue) * 100)+'%'"></div>
          </div>
        </div>
        <div class="divider mt-2px" *ngIf="i < data?.ivtDistribution?.givtFraudTypes?.length - 1"></div>
      </ng-container>
    </div>
  </div>
</div>
